// ============================================================================
// PATIENT WEB — shared session layer.
// Same token + patient-summary storage contract as the APK preview
// (patient-apk-preview/src/api/patientSession.ts) so ONE login works on both.
// STORAGE NOTE: localStorage is PREVIEW/DEV ONLY. The production mobile app
// must replace this with secure storage (Keychain/Keystore) — mobile team task.
// No secrets. No hardcoded production URLs (base comes from env / http.ts).
// ============================================================================

const TOKEN_KEY = 'nhc_patient_token';
const SUMMARY_KEY = 'nhc_patient_summary';

export interface PatientSummary {
  patientId: string;
  nhcId: string;
  fullName: string;
  phone?: string;
  email?: string;
}

export function saveToken(token: string): void {
  try { localStorage.setItem(TOKEN_KEY, token); } catch { /* preview */ }
}
export function readToken(): string | null {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}
export function clearToken(): void {
  try { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(SUMMARY_KEY); } catch { /* preview */ }
}

export function savePatientSummary(p: PatientSummary): void {
  try { localStorage.setItem(SUMMARY_KEY, JSON.stringify(p)); } catch { /* preview */ }
}
export function readPatientSummary(): PatientSummary | null {
  try {
    const raw = localStorage.getItem(SUMMARY_KEY);
    return raw ? (JSON.parse(raw) as PatientSummary) : null;
  } catch { return null; }
}

export function isLoggedIn(): boolean {
  return !!readToken();
}
